import React from 'react';
import PropTypes from 'prop-types';

import MobileFooter from '../../../containers/layout/MobileFooter';

const isMobile = screen.width < 966;

const Page = ({ header, main, footer }) => (
  <div className="page">
    <div className="page-header">{header}</div>
    <div className="page-main" id="page-main">
      {main}
      {isMobile && <MobileFooter />}
    </div>
    {!isMobile && footer}
  </div>
);

Page.propTypes = {
  header: PropTypes.node,
  main: PropTypes.node,
  footer: PropTypes.node
};

export default Page;
